<template>
  <div id="app" :class="isEndLogin==false?'':'ispadding'">
    <router-view class="container" v-if="isRouterAlive" />
    <div class="addressaaa" ><span v-html="htmlWord"></span><a href='https://beian.miit.gov.cn/'>浙ICP备19022020号</a></div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true,
      isEndLogin: true,
      htmlWord:
        "Copyright&nbsp©&nbsp2016-2024&nbsp浙江桃园智能科技有限公司&nbsp&nbsp|&nbsp&nbsp "
    };
  },
  mounted() {
    setInterval(function(){
      // console.log($('#app>div:first-child').css('backgroundColor'))
      $('#app>.addressaaa').css({
        'background-color':$('#app>div:first-child').css('backgroundColor')
      })
      $('#app').css({
        'background-color':$('#app>div:first-child').css('backgroundColor')
      })
      $('body').css({
        'background-color':$('#app>div:first-child').css('backgroundColor')
      })
    },100)
    // console.log(this.isEndLogin);
    // console.log(sessionStorage.getItem("user"),sessionStorage.getItem("findUserZhPw"),sessionStorage.getItem("flag"));
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style>
@import './common/font/font.css';
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
}
.ispadding{
  padding-bottom: 10px;
 }
#app > .container {
  min-height: 800px;
}
#app > .addressaaa {
  position: absolute;
  /* left: 0;
  bottom: 0; */
  bottom: 0;
  width: 100%;
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  /* background:rgba(255,255,255,0); */
    /* padding-top: 30px; */
    z-index:0;
}
li {
  list-style: none;
}
* {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue